module.exports = __webpack_public_path__ + "static/media/banner passport .53c1e5d2.jpg";